import { AutogenModelGlAssignment, AutogenRowGlAssignment } from "./autogen/AutogenModelGlAssignment";

export class ModelGlAssignment extends AutogenModelGlAssignment<RowGlAssignment> {
    constructor() {
        super(RowGlAssignment);
    }
}

export class RowGlAssignment extends AutogenRowGlAssignment {
}